<template>
<div class="weekly-labour-table">
    <div class="title clear">
        <div class="label">
            Actual Weekly Operation
        </div>
    </div>
    <div class="weekly-table-outline">
        <div class="table-head clear">
            <div class="table-head-left"></div>
            <div class="table-head-week" v-for="(day, i) in 7" :key="`day${day}${i}`">
                <h3>{{ $box.dayHeadOrganizer(weekStart, i) }}</h3>
                <h4>{{ formattedDate(day) }}</h4>
            </div>
            <div class="table-head-week"> <h3>Total</h3> </div>
        </div>
        <div v-if="tableData.length > 0 && !loading && showLabourHourly">
            <div class="table-oldest" v-for="(item, index) in tableData" :key="index">
                <div class="table-body-line clear" v-if="weekStart === 1"> <div class="table-line-left font16 pad-lft-20">{{item.left}} <div v-if="item.left === 'Labour +/-'" class="switchLabour" @click="labourHourlyChange"></div></div> <div class="table-line-data" :class="item.monColor">{{item.mon}}</div> <div class="table-line-data" :class="item.tueColor">{{item.tue}}</div> <div class="table-line-data" :class="item.wedColor">{{item.wed}}</div> <div class="table-line-data" :class="item.thuColor">{{item.thu}}</div> <div class="table-line-data" :class="item.friColor">{{item.fri}}</div> <div class="table-line-data" :class="item.satColor">{{item.sat}}</div> <div class="table-line-data" :class="item.sunColor">{{item.sun}}</div> <div class="table-line-data" :class="item.totalColor">{{item.total}}</div></div>
                <div class="table-body-line clear" v-if="weekStart === 2"> <div class="table-line-left font16 pad-lft-20">{{item.left}} <div v-if="item.left === 'Labour +/-'" class="switchLabour" @click="labourHourlyChange"></div></div> <div class="table-line-data" :class="item.tueColor">{{item.tue}}</div> <div class="table-line-data" :class="item.wedColor">{{item.wed}}</div> <div class="table-line-data" :class="item.thuColor">{{item.thu}}</div> <div class="table-line-data" :class="item.friColor">{{item.fri}}</div> <div class="table-line-data" :class="item.satColor">{{item.sat}}</div> <div class="table-line-data" :class="item.sunColor">{{item.sun}}</div> <div class="table-line-data" :class="item.monColor">{{item.mon}}</div> <div class="table-line-data" :class="item.totalColor">{{item.total}}</div></div>
                <div class="table-body-line clear" v-if="weekStart === 3"> <div class="table-line-left font16 pad-lft-20">{{item.left}} <div v-if="item.left === 'Labour +/-'" class="switchLabour" @click="labourHourlyChange"></div></div> <div class="table-line-data" :class="item.wedColor">{{item.wed}}</div> <div class="table-line-data" :class="item.thuColor">{{item.thu}}</div> <div class="table-line-data" :class="item.friColor">{{item.fri}}</div> <div class="table-line-data" :class="item.satColor">{{item.sat}}</div> <div class="table-line-data" :class="item.sunColor">{{item.sun}}</div> <div class="table-line-data" :class="item.monColor">{{item.mon}}</div> <div class="table-line-data" :class="item.tueColor">{{item.tue}}</div> <div class="table-line-data" :class="item.totalColor">{{item.total}}</div></div>
                <div class="table-body-line clear" v-if="weekStart === 4"> <div class="table-line-left font16 pad-lft-20">{{item.left}} <div v-if="item.left === 'Labour +/-'" class="switchLabour" @click="labourHourlyChange"></div></div> <div class="table-line-data" :class="item.thuColor">{{item.thu}}</div> <div class="table-line-data" :class="item.friColor">{{item.fri}}</div> <div class="table-line-data" :class="item.satColor">{{item.sat}}</div> <div class="table-line-data" :class="item.sunColor">{{item.sun}}</div> <div class="table-line-data" :class="item.monColor">{{item.mon}}</div> <div class="table-line-data" :class="item.tueColor">{{item.tue}}</div> <div class="table-line-data" :class="item.wedColor">{{item.wed}}</div> <div class="table-line-data" :class="item.totalColor">{{item.total}}</div></div>
                <div class="table-body-line clear" v-if="weekStart === 5"> <div class="table-line-left font16 pad-lft-20">{{item.left}} <div v-if="item.left === 'Labour +/-'" class="switchLabour" @click="labourHourlyChange"></div></div> <div class="table-line-data" :class="item.friColor">{{item.fri}}</div> <div class="table-line-data" :class="item.satColor">{{item.sat}}</div> <div class="table-line-data" :class="item.sunColor">{{item.sun}}</div> <div class="table-line-data" :class="item.monColor">{{item.mon}}</div> <div class="table-line-data" :class="item.tueColor">{{item.tue}}</div> <div class="table-line-data" :class="item.wedColor">{{item.wed}}</div> <div class="table-line-data" :class="item.thuColor">{{item.thu}}</div> <div class="table-line-data" :class="item.totalColor">{{item.total}}</div></div>
                <div class="table-body-line clear" v-if="weekStart === 6"> <div class="table-line-left font16 pad-lft-20">{{item.left}} <div v-if="item.left === 'Labour +/-'" class="switchLabour" @click="labourHourlyChange"></div></div> <div class="table-line-data" :class="item.satColor">{{item.sat}}</div> <div class="table-line-data" :class="item.sunColor">{{item.sun}}</div> <div class="table-line-data" :class="item.monColor">{{item.mon}}</div> <div class="table-line-data" :class="item.tueColor">{{item.tue}}</div> <div class="table-line-data" :class="item.wedColor">{{item.wed}}</div> <div class="table-line-data" :class="item.thuColor">{{item.thu}}</div> <div class="table-line-data" :class="item.friColor">{{item.fri}}</div> <div class="table-line-data" :class="item.totalColor">{{item.total}}</div></div>
                <div class="table-body-line clear" v-if="weekStart === 7"> <div class="table-line-left font16 pad-lft-20">{{item.left}} <div v-if="item.left === 'Labour +/-'" class="switchLabour" @click="labourHourlyChange"></div></div> <div class="table-line-data" :class="item.sunColor">{{item.sun}}</div> <div class="table-line-data" :class="item.monColor">{{item.mon}}</div> <div class="table-line-data" :class="item.tueColor">{{item.tue}}</div> <div class="table-line-data" :class="item.wedColor">{{item.wed}}</div> <div class="table-line-data" :class="item.thuColor">{{item.thu}}</div> <div class="table-line-data" :class="item.friColor">{{item.fri}}</div> <div class="table-line-data" :class="item.satColor">{{item.sat}}</div> <div class="table-line-data" :class="item.totalColor">{{item.total}}</div></div>
            </div>
        </div>
        <div v-else-if="loading" class="not-yet">
            <i class="el-icon-loading"></i>
        </div>
        <div v-else-if="!loading && tableData.length === 0" class="not-yet">
            No Data
        </div>
    </div>
</div>
</template>

<script>
import moment from "moment";
export default {
    name: 'weeklyLabourTable',
    props: {
        startDate: {
            type: String,
            default: ''
        },
        weekStart: {
            type: Number,
            default: 1
        },
        currentWeek: {
            type: Array,
            default: []
        },
        list: {
            type: Array,
            default: () => {
                return []
            }
        },
        labourHourlyRate: {
            type: Array,
            default: () => {
                return []
            }
        },
        loading: {
            type: Boolean,
            default: false
        },
    },
    data() {
		return {
            tableData: [],
            showLabourHourly: true
		}
	},
    methods: {
        labourHourlyChange() {
            var that = this;
            this.showLabourHourly = false;
            if (that.tableData[0].type === "hourly") {
                that.tableData[0] = that.labourHourlyRate[1];
            } else {
                that.tableData[0] = that.labourHourlyRate[0];
            }
            setTimeout(() => {
                this.showLabourHourly = true;
            }, 200);
        },

        formattedDate(day=1) {
            const dayyNum = day - 1;
            return moment(this.startDate).add(dayyNum, 'days').format('DD/MM');
        },

    },
    watch: {
        'list': {
            deep: true,
            handler: function (val) {
                this.tableData = val
            }
        }
    }
}
</script>

<style lang="scss" src="@/assets/css/dashborad.scss" scoped></style>


// WEBPACK FOOTER //
// src/components/dashboard/component/actualWeeklyOperation.vue